<form (submit)="onEditar($event)" class="space-y-3 sm:space-y-4 p-0">
  <!-- Número de documento -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-slate-700 mb-1">Número de Doc.</label>
    <div class="flex flex-col sm:flex-row items-stretch gap-2 sm:gap-3">
      <app-select class="w-full sm:hidden" [options]="tipoBusqueda" [formField]="$any(formularioCliente.tipo_documento)" placeholder="Tipo de documento" />
      <div class="hidden sm:inline-flex shrink-0">
        <app-select-button [options]="tipoBusqueda" [value]="formularioCliente.tipo_documento().controlValue()" (onChange)="formularioCliente.tipo_documento().value.set($event)" ariaLabel="Tipo de documento" />
      </div>
      <app-input class="flex-1" inputId="search" [value]="formularioCliente.dniRuc().value()" (valueChange)="formularioCliente.dniRuc().value.set($event)" [placeholder]="'Ingresar ' + (formularioCliente.tipo_documento().controlValue() | tipo_documento)" [invalid]="formularioCliente.dniRuc().invalid() && formularioCliente.dniRuc().touched()" />
    </div>
    @if ((formularioCliente.dniRuc().invalid() && formularioCliente.dniRuc().touched()) || (formularioCliente.tipo_documento().invalid() && formularioCliente.tipo_documento().touched())) {
      <small class="text-red-600 text-xs block mt-1">{{ formularioCliente.tipo_documento().errors() | formErrorMessage }}</small>
    }
  </div>

  <!-- Nombre -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-slate-700 mb-1">Nombre</label>
    <div class="flex items-center rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 overflow-hidden"
      [class.border-red-400]="formularioCliente.nombre().invalid() && formularioCliente.nombre().touched()">
      <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
        <i class="bi bi-person text-sm"></i>
      </span>
      <input
        id="nombre"
        type="text"
        [formField]="$any(formularioCliente.nombre)"
        class="w-full border-0 bg-transparent py-2 sm:py-2.5 pr-3 text-sm focus:outline-none focus:ring-0 placeholder:text-slate-400"
        placeholder="Ingrese el nombre completo"
      />
    </div>
    @if (formularioCliente.nombre().invalid() && formularioCliente.nombre().touched()) {
      <small class="text-red-600 text-xs block mt-1">{{ formularioCliente.nombre().errors() | formErrorMessage }}</small>
    }
  </div>

  <!-- Dirección -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-slate-700 mb-1">Dirección</label>
    <div class="flex items-center rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 overflow-hidden"
      [class.border-red-400]="formularioCliente.direccion().invalid() && formularioCliente.direccion().touched()">
      <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
        <i class="bi bi-geo-alt text-sm"></i>
      </span>
      <input
        id="direccion"
        type="text"
        [formField]="$any(formularioCliente.direccion)"
        autocomplete="street-address"
        class="w-full border-0 bg-transparent py-2 sm:py-2.5 pr-3 text-sm focus:outline-none focus:ring-0 placeholder:text-slate-400"
        placeholder="Ingrese la dirección"
      />
    </div>
    @if (formularioCliente.direccion().invalid() && formularioCliente.direccion().touched()) {
      <small class="text-red-600 text-xs block mt-1">{{ formularioCliente.direccion().errors() | formErrorMessage }}</small>
    }
  </div>

  <!-- Número de Celular -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-slate-700 mb-1">Número de Celular</label>
    <div class="flex items-center rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 overflow-hidden">
      <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
        <i class="bi bi-telephone text-sm"></i>
      </span>
      <app-input-mask
        inputId="numero_celular"
        mask="999-999-999"
        [(value)]="numero_celular"
        placeholder="999-999-999"
        styleClass="!border-0 !rounded-none !shadow-none"
        class="flex-1"
      />
    </div>
    @if (numero_celular && numero_celular.length > 0 && numero_celular.length < 9) {
      <small class="text-red-600 text-xs block mt-1">El número de celular es inválido.</small>
    }
  </div>

  <!-- Botones -->
  <div class="flex flex-col-reverse sm:flex-row justify-center gap-2 sm:gap-3 pt-2 sm:pt-4">
    <app-button label="Cancelar" variant="secondary" (onClick)="onCerrar()" class="w-full sm:w-auto [&>button]:w-full sm:[&>button]:w-auto" />
    <app-button type="submit" label="Editar Cliente" [disabled]="formularioCliente().invalid()" class="w-full sm:w-auto [&>button]:w-full sm:[&>button]:w-auto" />
  </div>
</form>
